import { waitForElement } from '../../../js/utils'

class Layout {
  constructor() {
    this.render()
  }

  render() {
    this.addClasses()
  }

  addClasses() {
    waitForElement('#_EnSiteWrapper_').then((siteWrapper) => {
      siteWrapper.classList.add('container')
    })
  }
}

export default Layout
